module.exports = __webpack_public_path__ + "public/images/slider/Muradyan-circle.c8adc03f0bfac3782222f0771529e83c.jpg";